// extracted by mini-css-extract-plugin
module.exports = {"heading":"add-to-cart-dialog_heading___pFWO","cartProductItem":"add-to-cart-dialog_cartProductItem__qRvTf"};